import type {
  OpenFinanceCardSyncResultDTO,
  OpenFinanceSyncAnyDTO,
  OpenFinanceSyncResultDTO,
} from '../services/open-finance.service';

// Link fixo, sem ids: o consentimento de cada banco é gerido no próprio mcp.ai (spec §4.2).
export const MCPAI_CONSENTIMENTOS_URL = 'https://app.mcp.ai';

/** Códigos de erro da busca que têm explicação; os outros aparecem como vieram. */
export const ERROS_OPEN_FINANCE: Record<string, string> = {
  TRANSACTIONS_NOT_SHARED: 'banco não compartilha as transações',
  not_connected: 'conexão do banco caiu',
};

function ehCartao(r: OpenFinanceSyncAnyDTO): r is OpenFinanceCardSyncResultDTO {
  return 'cardId' in r;
}

/** Resumo do "Buscar agora": linhas das contas, faturas dos cartões e quantos deram erro. */
export function resumoDaBusca(r: OpenFinanceSyncAnyDTO[]): { texto: string; comErro: number } {
  const contas = r.filter((x): x is OpenFinanceSyncResultDTO => !ehCartao(x));
  const cartoes = r.filter(ehCartao);
  const novas = contas.reduce((s, x) => s + (x.added ?? 0), 0);
  const contasComErro = contas.filter((x) => x.error).length;
  const cartoesComErro = cartoes.filter((x) => x.error).length;
  const partes = [`Busca concluída: ${novas} linha(s) nova(s)`];
  if (cartoes.length > 0) {
    const faturas = cartoes.reduce((s, x) => s + (x.invoicesCreated ?? 0), 0);
    const estimadas = cartoes.reduce((s, x) => s + (x.estimatedInvoices ?? 0), 0);
    partes.push(`${faturas} fatura(s) nova(s)${estimadas ? ` (${estimadas} estimada(s))` : ''}`);
  }
  if (contasComErro) {
    partes.push(`${contasComErro} conta(s) com erro`);
  }
  if (cartoesComErro) {
    partes.push(`${cartoesComErro} cartão(ões) com erro`);
  }
  return { texto: partes.join(', '), comErro: contasComErro + cartoesComErro };
}

export function erroDaBusca(err: unknown): string {
  const resp = (err as { response?: { status?: number; data?: { message?: string } } } | null)
    ?.response;
  const status = resp?.status;
  const msg = resp?.data?.message;
  if (msg) {
    return msg;
  }
  if (status === 409) {
    return 'Open Finance desligado';
  }
  if (status === 502) {
    return 'Open Finance indisponível: o provedor não respondeu';
  }
  return 'Falha ao buscar no Open Finance';
}
